import client from '../base-api';

const serviceURL = '/security';

const securityService = {
  changePassword(formData: any): Promise<any> {
    return client.put(`${serviceURL}/change-password`, formData);
  },
  changePasswordForUser(formData: any, userId: number): Promise<any> {
    return client.put(`${serviceURL}/change-password-for-user/${userId}`, formData);
  },
  impersonate(data: any) {
    return client.post(`${serviceURL}/impersonate`, data);
  },
  stopImpersonation() {
    return client.post(`${serviceURL}/stop-impersonation`);
  },
};

export default securityService;
